import { useStaticIntl } from '@tribeplatform/react-components/i18n'
import { useBlock } from '@tribeplatform/react-slate-kit/hooks'
import type { BC } from '@tribeplatform/react-slate-kit/types'

import { MultiViewBlock } from '../Views/components/MultiViewBlock'
import { CollectionSpacesList } from './components/CollectionSpacesList'
import { SpecificSpacesList } from './components/SpecificSpacesList'
import { genericViewFactory, staticFieldsFactory } from './config'
import type { SpacesListBlockProps } from './types'

export const SpacesListBlock: BC<SpacesListBlockProps> = ({
  title,
  description,
  linkText,
  linkUrl,
  views,
}) => {
  const {
    extraContext: { activeViewIndex, activeFieldId },
  } = useBlock<
    SpacesListBlockProps,
    { activeViewIndex?: number; activeFieldId?: string }
  >()
  const genericView = useStaticIntl(genericViewFactory)
  const staticFields = useStaticIntl(staticFieldsFactory)

  return (
    <MultiViewBlock
      activeViewIndex={activeViewIndex}
      title={title}
      description={description}
      views={views}
      linkUrl={linkUrl}
      linkText={linkText}
    >
      {({ view, preview }) => (
        <>
          {view && view.filterBy === 'collectionId' && (
            <CollectionSpacesList
              view={view}
              activeFieldId={activeFieldId}
              preview={preview}
            />
          )}
          {view && view.filterBy === 'spaceSlugs' && (
            <SpecificSpacesList
              view={view}
              activeFieldId={activeFieldId}
              preview={preview}
            />
          )}
          {!view && (
            <CollectionSpacesList
              activeFieldId={activeFieldId}
              view={{
                ...genericView,
                fields: staticFields,
              }}
              preview={preview}
            />
          )}
        </>
      )}
    </MultiViewBlock>
  )
}
